import portalVue from "@/vendor/portal-vue";
import gtm from "@/vendor/vue-gtm";
import lazyload from "@/vendor/vue-lazyload";
import meta from "@/vendor/vue-meta";
import transmit from "@/vendor/vue-transmit";

export default () => {
  [transmit, lazyload, gtm, meta, portalVue].forEach(installer => installer());
};
